import { getRaw, postRaw } from 'services/api';
import { CampaignLabel, CampaignState } from 'modules/domains/campaign';

export const CAMPAIGNS_URL = '/campaigns.json';
export const EDIT_CAMPAIGN_NAME = '/campaigns/editCampaignName';
const CHANGE_CAMPAIGN_STATE = '/campaigns/changeState';
const ABORT_CAMPAIGN = '/campaigns/abort';
const EDIT_CAMPAIGN_LABELS = '/i/campaignLabels/';

/* used during the fetchCampaignDetailsSaga templatePicker saga
   while the CAMPAIGNS_URL may return information 
   on a whole list of campaigns, it can be used to
   return information for a specific campaign. 

   which is what we need to populate the correct template types 
   during the reactified campaign picker template flow
*/
export const getCampaignDetails = (campaignId: number) => {
  // since the API endpoint returns a list of campaings.
  // it requires a bunch of arguments. By adding a "@campaignId=[number]"
  // we override all those other arguments and return a list of just that campaign
  const queryConstants = 'page=1&pageSize=1&orderBy=asc&sorting=desc';
  return getRaw(`${CAMPAIGNS_URL}?campaignId=${campaignId}&${queryConstants}`).then(
    ({ data }) => data?.results?.[0],
  );
};

export const editCampaignName = (id: number, name: string) => {
  return postRaw(EDIT_CAMPAIGN_NAME, { campaignId: id, name });
};

export const editCampaignLabels = (id: number, labels: CampaignLabel[]) => {
  return postRaw(`${EDIT_CAMPAIGN_LABELS}${id}`, { labels });
};

export const changeCampaignState = (id: number, campaignState: CampaignState) => {
  return postRaw(CHANGE_CAMPAIGN_STATE, { campaignId: id, campaignState });
};

export const abortCampaign = (id: number) => {
  return postRaw(ABORT_CAMPAIGN, { campaignId: id });
};
